export const ru = {
    access: 'Доступ к кампаниям',
    additional: 'Дополнительные возможности',
    'agency-management': 'Управление клиентами',
    'agency:': 'Представитель агентства:',
    api: 'API',
    'client-new-campaigns-in-BYN':
        'Новые кампании клиента в белорусских рублях',
    'client-new-campaigns-in-CHF':
        'Новые кампании клиента в швейцарских франках',
    'client-new-campaigns-in-EUR': 'Новые кампании клиента в евро',
    'client-new-campaigns-in-KZT': 'Новые кампании клиента в тенге',
    'client-new-campaigns-in-RUB': 'Новые кампании клиента в российских рублях',
    'client-new-campaigns-in-TRY': 'Новые кампании клиента в турецких лирах',
    'client-new-campaigns-in-UAH':
        'Новые кампании клиента в украинских гривнах',
    'client-new-campaigns-in-USD': 'Новые кампании клиента в долларах США',
    'client-new-campaigns-in-YND_FIXED': 'Новые кампании клиента в у.е.',
    'dobavit-kampaniyu-klientu': 'Добавить кампанию клиенту',
    fidy: 'Фиды',
    'interfeys-internacionalizacii': 'Интерфейс интернационализации',
    'istoria-izmenenii': 'История изменений',
    kommander: 'Коммандер',
    'kreativy-dlya-smart-bannerov': 'Креативы для смарт-баннеров',
    lists: 'Общие списки',
    management: 'Управление кампаниями',
    'manager:': 'Менеджер:',
    'master-zapolneniya-virtualnyh-vizitok':
        'Мастер заполнения виртуальных визиток',
    'mobile-apps': 'Список приложений',
    'moi-starye-kampanii-v-124': 'Мои старые кампании в у.е.',
    'monitoring-izmeneniy-poziciy-po': 'Мониторинг изменений позиций по фразам',
    moscow: 'Москва',
    'my-new-campaigns-in-BYN': 'Мои новые кампании в белорусских рублях',
    'my-new-campaigns-in-CHF': 'Мои новые кампании в швейцарских франках',
    'my-new-campaigns-in-EUR': 'Мои новые кампании в евро',
    'my-new-campaigns-in-KZT': 'Мои новые кампании в тенге',
    'my-new-campaigns-in-RUB': 'Мои новые кампании в российских рублях',
    'my-new-campaigns-in-TRY': 'Мои новые кампании в турецких лирах',
    'my-new-campaigns-in-UAH': 'Мои новые кампании в украинских гривнах',
    'my-new-campaigns-in-USD': 'Мои новые кампании в долларах США',
    'my-new-campaigns-in-YND_FIXED': 'Мои новые кампании в у.е.',
    payments: 'Бюджет и оплата',
    'perenos-sredstv-s-kampanii': 'Перенос средств с кампании на кампанию',
    'phone-extension': 'доб. {phone}',
    'poisk-dubley-v-klyuchevyh': 'Поиск дублей в ключевых словах',
    regions: 'Регионы',
    'skopirovat-kampaniyu': 'Скопировать кампанию',
    'spisok-klientov-agentstva': 'Список клиентов агентства',
    'starye-kampanii-klienta-v-125': 'Старые кампании клиента в у.е.',
    stat: 'Статистика',
    'statistika-po-starym-kampaniyam': 'Статистика по старым кампаниям в у.е.',
    'statistika-po-vsem-kampaniyam': 'Статистика по всем кампаниям',
    turbolandings: 'Турбо-страницы',
    'usloviya-podbora-auditorii': 'Ретаргетинг и аудитории',
    'xls-xlsx': 'XLS/XLSX',
    'zagruzit-dokumenty': 'Загрузить документы',
    'zakaz-otchetov': 'Заказ отчетов',
    'zaregistrirovannye-predstaviteli': 'Зарегистрированные представители'
};
